
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import WTPQuantityOfWaterPagePopup from './WTPQuantityOfWaterPagePopup'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../../../../../Helper/Context'
import { WTPQuantityOfWaterDeleteAPI, WTPQuantityOfWaterTableDataAPI, WTPQuantityOfWaterTableExportDataAPI } from '../../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/DataUploadSlice/QuantityOfWaterSlice'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { Loading } from '../../../../../../Helper/Loading'
import { EmployeeExportData } from '../../../MasterSideData/EmployeeDataExportPage'
import { WTPQuantityOfWaterExportData } from './ExportFile/WTPQuantityOfWaterExportFile'


export default function WTPQuantityOfWaterPage() {

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [WTPQuantityOfWaterPagePopupShow, setWTPQuantityOfWaterPagePopupShow] = useState(0)

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [FromDate, setFromDate] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    // const [Date, setDate] = useState(moment().format('YYYY-MM-DD'))


    // const date = Month?.ID != 0 && moment().month(Month?.ID - 1).format('YYYY-MM-DD');

    const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).format('YYYY-MM-DD'));

    const [Date, setDate] = useState(date ? date : moment().format('YYYY-MM-DD'))

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: Ward.ID,
        Label: Ward.Label,
    })


    const [PumpingStation, setPumpingStation] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setWTPQuantityOfWaterPagePopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setWTPQuantityOfWaterPagePopupShow(true)
        setapiFlag('Update')
        setrowData()
    }

    const handleOnCloseClick = () => {
        setWTPQuantityOfWaterPagePopupShow(false)
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleClear = () => {
        setCurrentPage(0)
        setIsClear(!IsClear)
        setDate(date ? date : moment().format('YYYY-MM-DD'))
        setWardName({
            ...WardName,
            ID:'0',
            Label:'Select...'
        })
        // console.log("call")
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    useEffect(() => {
        const data = {
            M_FinancialYearID: year.ID,
            M_MonthID: Month.ID,
            ReadingDate: Date,
            M_WardID: WardName.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            handleGetExport: handleGetExport
        }
        // if (WardName.ID != 0) {
        dispatch(WTPQuantityOfWaterTableDataAPI({ data }))
        // }

    }, [IsPost, From, To, isSearch, IsClear, WardName.ID, year.ID, Month.ID, Date])

    const { tableData, isLoading } = useSelector(state => state.WTPQuantityOfWaterTableData)

    const handleGetExport = () => {
        const data = {
            M_FinancialYearID: year.ID,
            M_MonthID: Month.ID,
            ReadingDate: Date,
            M_WardID: WardName.ID,
            M_UserID: UserID,
            token: token,
            From: '1',
            To: '99999',
        }
        dispatch(WTPQuantityOfWaterTableExportDataAPI({ data }))
    }
    const { ExporttableData, isExportLoading } = useSelector(state => state.WTPQuantityOfWaterTableExportData)

    // console.log('ExporttableData', ExporttableData)

    const handleDeleteApi = (item) => {
        const data = {
            T_WTP_WaterQuantityID: item.t_wtP_WaterQuantityID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(WTPQuantityOfWaterDeleteAPI({ data }))
    }

    return (
        <div>
            {isLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName} />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">
                    {/* <!-- [ breadcrumb ] start --> */}
                    {/* <!-- [ Main Content ] start --> */}
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>Quantity Of Water</h5>
                                <div className="float-end butt">
                                    {/* <i class="fa-solid fa-plus add_btn" style={{ color: "#010813", fontSize: '17px' }}><span className="ml-2">Add</span></i> */}
                                    {/* <button type="button" className="btn btn-primary float-end ml-1">Export</button> */}
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.length > 0 &&
                                            <WTPQuantityOfWaterExportData
                                                ExcelData={ExporttableData}
                                                name='Quantity of Water'
                                            // searchName={searchName}
                                            />
                                    }
                                    <i className="fa-solid fa-plus float-end btn btn-secondary"
                                        style={{ color: "white" }}
                                        onClick={handleAddOnClick}
                                    >
                                        <text className="ml-2 poppins">Add</text>
                                    </i>

                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">
                                        <div className="row py-1 rounded2">
                                            <div className="col-12 col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"> <b>Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="Date"
                                                        value={Date}
                                                        onChange={(e) => (setDate(e.target.value))}
                                                    />

                                                </div>
                                            </div>

                                            <div className="col-lg-3 col-md-6">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                />

                                            </div>

                                            {/* <div className="col-lg-3 col-md-6">
                                                <label for=""><b>Pumping Station </b></label>
                                                <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    // className="ddl_width"
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: PumpingStation.ID, label: PumpingStation.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setPumpingStation({ ...PumpingStation, ID: e.value, Label: e.label })
                                                            :
                                                            setPumpingStation({ ...PumpingStation, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={PumpingStation.DDL}
                                                />

                                            </div> */}
                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                {/* <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button> */}
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-2">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Date</th>
                                                        <th>Raw Water Received From Dam</th>
                                                        <th>Raw Water Supplied To MJP</th>
                                                        <th>Net Raw Water Supplied To NMMC</th>
                                                        <th>Treatment Loss in MLD</th>
                                                        <th>Quantity of Pure Water Pump From Pure Water Sump</th>
                                                        <th className='action_icon'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.length > 0 ? tableData.map((i) => (
                                                            <tr>
                                                                <td style={{ textAlign: "center" }}>{i?.rowNum ? i?.rowNum : '-'}</td>
                                                                <td style={{ whiteSpace: 'nowrap' }}>{i?.readingDate ? moment(i?.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                                <td>{i?.rawWaterReceivedFromDam ? i?.rawWaterReceivedFromDam.toFixed(2) : 0}</td>
                                                                <td style={{ textAlign: 'right' }}>{i?.rawWaterSuppliedToMJP ? i?.rawWaterSuppliedToMJP.toFixed(2) : 0}</td>
                                                                <td style={{ textAlign: 'right' }}>{i?.netRawWaterSuppliedToNMMC ? i?.netRawWaterSuppliedToNMMC.toFixed(2) : 0}</td>
                                                                <td style={{ textAlign: 'right' }}>{i?.treatmentLossInMLD ? i?.treatmentLossInMLD.toFixed(2) : 0}</td>
                                                                <td style={{ textAlign: 'right' }}>{i?.quantityofPureWater ? i?.quantityofPureWater.toFixed(2) : 0}</td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    {/* <span>
                                                                        <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleEditOnClick()}
                                                                        >
                                                                        </i>
                                                                    </span> */}
                                                                    <span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={i}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>
                                            {tableData && tableData.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    WTPQuantityOfWaterPagePopupShow ?
                        <WTPQuantityOfWaterPagePopup
                            open={WTPQuantityOfWaterPagePopupShow}
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                        // Flag={apiFlag}
                        // rowData={rowData}
                        />
                        : <></>
                }

            </div>
        </div>



    )
}